import axios from 'axios';

const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL || 'http://localhost:5002';
const API_PATH = '/hospital-portal/api/doctor-dashboard';

const getHeaders = (token) => ({
    headers: { Authorization: `Bearer ${token}` }
});

const buildQueryString = (params = {}) => {
    const query = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return;
        query.set(key, value);
    });

    const queryString = query.toString();
    return queryString ? `?${queryString}` : '';
};

/**
 * Bundled init — returns profile, visits, labs, radiology, stats in one call
 */
export const fetchDashboardInit = async (token, date) => {
    const query = buildQueryString({ date });
    const response = await axios.get(`${BASE_URL}${API_PATH}/init${query}`, getHeaders(token));
    return response.data;
};

/**
 * Get doctor profile for the logged-in user
 */
export const fetchDoctorProfile = async (token) => {
    const response = await axios.get(`${BASE_URL}${API_PATH}/profile`, getHeaders(token));
    return response.data;
};

/**
 * Get today's visits for the logged-in doctor
 */
export const fetchTodayVisits = async (token, date) => {
    const query = buildQueryString({ date });
    const response = await axios.get(`${BASE_URL}${API_PATH}/visits-today${query}`, getHeaders(token));
    return response.data;
};

/**
 * Get today's visits for all doctors
 */
export const fetchTodayAllVisits = async (token, date) => {
    const query = buildQueryString({ date });
    const response = await axios.get(`${BASE_URL}${API_PATH}/visits-today-all${query}`, getHeaders(token));
    return response.data;
};

/**
 * Get today's lab/radiology requests
 * @param {string} token
 * @param {string} [type] - 'Laboratory' or 'Radiology' (optional)
 */
export const fetchTodayLabRequests = async (token, type, date) => {
    const query = buildQueryString({ type, date });
    const response = await axios.get(`${BASE_URL}${API_PATH}/lab-requests-today${query}`, getHeaders(token));
    return response.data;
};

/**
 * Get dashboard summary stats
 */
export const fetchDashboardStats = async (token) => {
    const response = await axios.get(`${BASE_URL}${API_PATH}/stats`, getHeaders(token));
    return response.data;
};

/**
 * Generate or refresh cached AI patient summary for visit cards.
 */
export const generatePatientVisitSummary = async (token, patientId) => {
    const response = await axios.post(
        `${BASE_URL}/hospital-portal/api/ai/patient-visit-summary`,
        { patient_id: patientId },
        getHeaders(token)
    );
    return response.data;
};
